import { api } from '../axios.helper';
import { Config, ProgrammeThemeDayDto } from '@ecdlink/core';
import { ProgrammeThemeDto } from '@ecdlink/core';
class ContentProgrammeThemeService {
  _accessToken: string;

  constructor(accessToken: string) {
    this._accessToken = accessToken;
  }

  async getProgrammeThemes(locale: string): Promise<ProgrammeThemeDto[]> {
    const apiInstance = api(Config.graphQlApi, this._accessToken);
    const response = await apiInstance.post<any>(``, {
      id: 'GetAllTheme',
      variables: {
        locale: locale,
      },
    });

    if (response.status !== 200) {
      throw new Error('Get Programme themes Failed - Server connection error');
    }

    return response.data.data.allThemesV2.map(
      (t: any) =>
        ({
          id: t.id,
          name: t.name,
          color: t.color,
          imageUrl: t.imageUrl,
          themeDays: t.themeDays.map(
            (td: any) =>
              ({
                id: td.id,
                day: td.day,
                largeGroupActivity: { id: td.largeGroupActivityId },
                smallGroupActivity: { id: td.smallGroupActivityId },
                storyActivity: { id: td.storyActivityId },
                storyBook: { id: td.storyBookId },
              } as unknown as ProgrammeThemeDayDto)
          ),
        } as ProgrammeThemeDto)
    );
  }
}

export default ContentProgrammeThemeService;
